import css from "./HeaderHome.module.css";

function HeaderHome() {
    return (
        <header className={css.header}>

            {/* LOGO */}
            <a href="/" className={css.logoheader}>
                <img className={css.logop} src="/logop.jpg" alt="Logo NeuroAudio"/>
                <span>NeuroAudio</span>
            </a>

            {/* TÍTULO */}
            <h1 className={css.tituloheader}>
                TRANSFORMAR VIDAS ATRAVÉS DA <br/>
                SAÚDE AUDITIVA E DO EQUILÍBRIO
            </h1>

            {/* BOTÕES */}
            <div className={css.botoes}>
                <a href="/tratamentos">
                    <button className={css.servicos}>
                        Ver nossos serviços
                    </button>
                </a>

                <a href="/contatos">
                    <button className={css.servicos}>
                        Fale Conosco
                    </button>
                </a>
            </div>

        </header>
    );
}

export default HeaderHome;